interface FormHeaderProps {
  title?: string | JSX.Element;
  notes?: string;
}

export default function FormHeader({
  title = '',
  notes = 'This information helps us understand your needs better. It may be visible to Bible copyright holders and to our support staff.',
}: FormHeaderProps) {
  return (
    <div>
      {typeof title === 'string' && title ? (
        <h2 className="mb-6 text-xl font-bold">{title}</h2>
      ) : (
        title
      )}
      <div className="text-gray-500 italic mb-6">{notes}</div>
    </div>
  );
}
